import PcRouter from './pc_router'

const Routers = () => {
    return <PcRouter></PcRouter>
}

export default Routers